import { Injectable } from '@angular/core';
import { IRequestCallback, IRequestCallbackFunction, RequestService } from '@df/api/request/request.service';
import { LocalStorage } from '@df/browser/storage/decorator/local-storage';
import { Status } from '@df/core/status';
import compact from 'lodash-es/compact';
import flatten from 'lodash-es/flatten';
import last from 'lodash-es/last';

export interface IFileBufferItem {
    path: string;
}

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    /**
     * Buffer data
     */
    @LocalStorage('file-upload.buffer')
    buffer?: IFileBufferItem[];

    constructor(protected requestService: RequestService) {}

    /**
     * Adds file to customer buffer
     */
    add(status: Status, file: File, onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        return this.requestService.send(
            status,
            { path: 'util/upload', data: { file } },
            compact<IRequestCallbackFunction>(flatten([onSuccess, result => this.onAddSuccess(result)])),
            onError,
            { fileUpload: true }
        );
    }

    /**
     * Removes item from buffer and deletes it in BE
     * @return {array}
     */
    remove(item: IFileBufferItem) {
        const buffer = this.buffer;
        if (buffer) {
            buffer.splice(buffer.indexOf(item), 1);
        }
        // remove from BE
        this.requestService.send(undefined, {
            path: 'util/deleteFile',
            data: { files: [item.path] }
        });
    }

    /**
     * Retrieves last added file
     */
    getLast(): IFileBufferItem | undefined {
        return last(this.buffer);
    }

    /**
     * Called on add success
     * Adds results to buffer
     */
    protected onAddSuccess(result: { files: IFileBufferItem[] }) {
        const item = result.files[0];
        this.buffer?.push(item);
        return item;
    }
}
